import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import type { GameController } from './controller';

export const ControllerContext = createContext<GameController | null>(null);

export function useController(): GameController {
  const controller = useContext(ControllerContext);
  if (!controller)
    throw new Error('GameController не предоставлен: оберни приложение в ControllerContext.Provider');
  return controller;
}
